import { ProgressBar } from "primereact/progressbar";
import React from "react";

const CardVideoTraining = (props) => {
  const valueTemplate = (value) => {
    return (
      <React.Fragment>
        {value}
        <b>% Concluído</b>
      </React.Fragment>
    );
  };
  return (
    <>
      <div
        onClick={props.onClick}
        className="card-video bg-white border border-success"
      >
        <div className="row">
          <div
            className="col-9 d-flex align-items-center pt-2"
            style={{ height: "70px" }}
          >
            <h5 className="ms-3">{props.title}</h5>
          </div>
          <div
            className="col-2 icon-video d-flex align-items-center justify-content-end ms-2"
            style={{ height: "70px" }}
          >
            <i className={props.assisted}></i>
          </div>
        </div>
        <div className="d-flex w-100">
          <ProgressBar
            style={{ height: "15px", fontSize: "12px", width: "100%" }}
            color="#00ACAC"
            value={props.percentage}
            displayValueTemplate={valueTemplate}
          ></ProgressBar>
        </div>
      </div>
    </>
  );
};

export default CardVideoTraining;
